import React from "react";
import {Route, Routes} from "react-router-dom";

import Login from "../components/sessions/Login";
import LoginLayout from "../layout/LoginLayout";
import Register from "../components/users/Register";
import ClientsList from "../components/provider/clients/ClientsList";
import Profile from "../components/users/Profile";
import PlatesList from "../components/provider/plates/PlatesList";
import MenusList from "../components/provider/menus/MenusList";
import IngredientsList from "../components/provider/ingredients/IngredientsList";
import IngredientForm from "../components/provider/ingredients/IngredientForm";
import PlateForm from "../components/provider/plates/PlateForm";
import CategoriesList from "../components/provider/category/CategoriesList";
import CategoryForm from "../components/provider/category/CategoryForm";
import MenuForm from "../components/provider/menus/MenuForm";
import PrivateRoutes from "./PrivateRoutes";
import Home from "../components/pages/Home";
import PublicLayout from "../layout/PublicLayout/PublicLayout";
import ClientLayout from "../layout/ClientLayout/ClientLayout";
import ProviderLayout from "../layout/ProviderLayout/ProviderLayout";
import InviteClientForm from "../components/provider/clients/InviteClientForm";
import ClientDetails from "../components/provider/clients/ClientDetails";
import ClientDashboard from "../components/client/dashboards/ClientDashboard";
import ClientMenusList from "../components/client/menus/ClientMenusList";
import ClientMenuDetails from "../components/client/menus/ClientMenuDetails";
import ClientPlateDetails from "../components/client/plates/ClientPlateDetails";
import ClientProfile from "../components/users/ClientProfile";
import ShoppingList from "../components/client/shopping/ShoppingList";
import MeasurementsList from "../components/client/measurements/MeasurementsList";
import MeasurementForm from "../components/client/measurements/MeasurementForm";
import ClientFunctionalities from "../components/pages/ClientFunctionalities";
import ProviderFunctionalities from "../components/pages/ProviderFunctionalities";
import ClientMeasurementsList from "../components/provider/clients/ClientMeasurementsList";
import NotificationsList from "../components/provider/notifications/NotificationsList";
import Settings from "../components/users/Settings";
import Pricing from "../components/pages/Pricing";
import ReportsList from "../components/provider/reports/ReportsList";
import ContactForm from "../components/pages/ContactForm/ContactForm";
import PrivacyPolicy from "../components/pages/PrivacyPolicy";
import TermsAndConditions from "../components/pages/TermsAndConditions";
import MenuPlatesLayout from "../layout/ClientLayout/MenuPlatesLayout";

export default (
  <Routes>
    <Route element={<LoginLayout />}>
      <Route path="/login" element={<Login />} />
      <Route path="/login/msg/:message" element={<Login />} />
      <Route path="/inregistrare" element={<Register />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/:planId" element={<Register />} />
      <Route path="/register/err/:errors" element={<Register />} />
    </Route>

    <Route element={<PublicLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/preturi" element={<Pricing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/client_func" element={<ClientFunctionalities />} />
      <Route path="/provider_func" element={<ProviderFunctionalities />} />
      <Route path="/contact" element={<ContactForm />} />
      <Route path="/contact_us" element={<ContactForm />} />
      <Route path="/privacy_policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsAndConditions />} />
    </Route>

    <Route element={<PrivateRoutes userType="client" />}>
      <Route element={<ClientLayout />}>
        <Route path="/my_menus" element={<ClientMenusList />} />
        <Route path="/my_dashboard" element={<ClientDashboard />} />
        <Route path="/my_account" element={<ClientProfile />} />
        <Route path="/shopping_list" element={<ShoppingList />} />
        <Route path="/my_measurements" element={<MeasurementsList />} />
        <Route path="/my_measurements/new" element={<MeasurementForm />} />
        <Route path="/my_measurements/:id" element={<MeasurementForm />} />
      </Route>

      <Route element={<MenuPlatesLayout />}>
        <Route path="/my_menus/:id" element={<ClientMenuDetails />} />
        <Route path="/my_menu_items/:id" element={<ClientPlateDetails />} />
      </Route>
    </Route>

    <Route element={<PrivateRoutes userType="provider" />}>
      <Route element={<ProviderLayout />}>

        {/*<Route path="/dashboard" element={<Dashboard/>}/>*/}
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />

        <Route path="/menus" element={<MenusList />} />
        <Route path="/menus/new" element={<MenuForm />} />
        <Route path="/menus/:id" element={<MenuForm />} />

        <Route path="/categories" element={<CategoriesList />} />
        <Route path="/categories/new" element={<CategoryForm />} />
        <Route path="/categories/:id" element={<CategoryForm />} />

        <Route path="/plates" element={<PlatesList />} />
        <Route path="/plates/new" element={<PlateForm />} />
        <Route path="/plates/:id" element={<PlateForm />} />

        <Route path="/ingredients" element={<IngredientsList />} />
        <Route path="/ingredients/:id" element={<IngredientForm />} />
        <Route path="/ingredients/new" element={<IngredientForm />} />

        <Route path="/clients" element={<ClientsList />} />
        <Route path="/clients/new" element={<InviteClientForm />} />
        {/*<Route path="/clients/:id/edit" element={<InviteClientForm/>}/>*/}
        <Route path="/clients/:id" element={<ClientDetails />} />
        <Route path="/clients/:id/measurements" element={<ClientMeasurementsList />} />

        <Route path="/notifications" element={<NotificationsList />} />

        <Route path="/reports" element={<ReportsList />} />
      </Route>
    </Route>
  </Routes>
);
